import React, { useLayoutEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
const TOLERANCE = 0.05;
const CHILD_SIZE_RATIO = 1;
const FontSize = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  font-size: ${(props) => props.fontSize}px;
  line-height: 1;
  white-space: nowrap;
  ${(props) => props.$alignment === "center" ? css`
          display: flex;
          justify-content: center;
          align-items: center;
        ` : ""}
  ${(props) => props.$alignment === "bottom-right" ? css`
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
        ` : ""}

  ${(props) => props.$alignment === "bottom-left" ? css`
          display: flex;
          justify-content: flex-start;
          align-items: flex-end;
        ` : ""}
`;
const _multiplierForElement = (element, targetWidth, targetHeight) => {
  const contentWidth = element.offsetWidth;
  const contentHeight = element.offsetHeight;
  const widthMultiplier = targetWidth * CHILD_SIZE_RATIO / contentWidth;
  const heightMultiplier = targetHeight * CHILD_SIZE_RATIO / contentHeight;
  return Math.min(widthMultiplier, heightMultiplier);
};
const isValidFontSize = (fontSize) => fontSize !== 0 && Number.isFinite(fontSize);
const useAutoFontSize = (target, _container, height, width, children) => {
  const [fontSize, setFontSize] = useState(20);
  useLayoutEffect(() => {
    var _a;
    const container = target ? { current: { children: [target] } } : _container;
    const containerChildren = (_a = container == null ? void 0 : container.current) == null ? void 0 : _a.children;
    if (!containerChildren || containerChildren.length <= 0) {
      return;
    }
    const contentElement = containerChildren[0];
    const multiplier = _multiplierForElement(contentElement, width, height);
    const isOverflowing = multiplier < 1;
    if (!isOverflowing && multiplier - 1 <= TOLERANCE) {
      return;
    }
    let newFontSize = Math.floor(fontSize * multiplier);
    if (isOverflowing && newFontSize >= fontSize) {
      newFontSize = fontSize - 1;
    }
    if (newFontSize !== fontSize && isValidFontSize(newFontSize)) {
      setFontSize(newFontSize);
    }
  }, [target, _container, fontSize, height, width, children]);
  return fontSize;
};
const AutoFontSizer = ({ children, target = null, height, width, alignment = void 0 }) => {
  const _container = useRef();
  const fontSize = useAutoFontSize(target, _container, height, width, children);
  const _mixedContainer = _container;
  return /* @__PURE__ */ React.createElement(FontSize, { $alignment: alignment, fontSize, ref: _mixedContainer }, children);
};
export default AutoFontSizer;
